import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import styles from '../AddOnModal/AddOnModal.module.scss';
import gridStyles from './BizBooster.module.scss';
import useClickAwayListener from '../../hooks/useClickAwayLitsner';
import { clickTracker, getSourceValue, handleRedirection } from '../../lib/common';

const DEFAULT_BG = '#f3f3f3';
const DEFAULT_TAG_COLOR = '#ff2d2d';

const BizBoosterModal = ({ addOnsData = [], setAddOnsData = () => {} }) => {
  const modalRef = useRef(null);
  const source = getSourceValue();

  const handleClose = () => {
    document.body.style.overflow = 'unset';
    setAddOnsData([]);
  };
  useClickAwayListener(modalRef, () => {
    handleClose();
  });

  const handleBuy = (card) => {
    clickTracker(`FAQ_view_${card?.trackerId || ''}`, 'addon_FAQ').catch((err) =>
      console.log('error in bizBooster clickTracker', err),
    );
    handleClose();
    handleRedirection(source, card?.redirectionUrl || '');
  };

  const queryParams = new URLSearchParams(window.location.search);
  const version = queryParams.get('version') ? parseFloat(queryParams.get('version') || '0') : 0;

  return (
    <section
      className={`cs_modal ${styles.AddOneModal} `}
      style={{ width: 'min(100%, 1098px)', right: 0, margin: '0 auto' }}
    >
      <div ref={modalRef} className={`cs_modal_content cs_modal_animation cs_modal_up ${styles.Content} `}>
        <div
          className="cs_modal_body"
          style={{
            paddingBottom: (source === 53 || source === '53') && version >= 3.3 ? 80 : 20,
          }}
        >
          <div className={`cs_modal_header ${styles.Header} p-20`}>
            <div className={`cs_modal_head_center ${styles.Center} font16 fw600 color111`}>Biz Boosters</div>
            <div className={`cs_modal_head_right ${styles.Right}`}>
              <div
                className="modal_close csicon"
                onClick={() => handleClose()}
                aria-label="Close Modal"
                type="button"
                tabIndex={0}
                role="button"
                onKeyDown={() => {}}
              />
            </div>
          </div>

          <section className={`${gridStyles.BizBooster} pl-20 pr-20 pt-15 pb-15`}>
            <div className={gridStyles.Grid}>
              {addOnsData?.map((card, idx) => {
                const hasPriceRow = card?.oldPrice || card?.off || card?.trending;
                return (
                  <div
                    key={card?.campid || card?.trackerId || idx}
                    className={gridStyles.Card}
                    style={{ backgroundColor: card?.bgColor || DEFAULT_BG }}
                  >
                    {card?.tag && (
                      <div
                        className={`${gridStyles.Tag} font11 fw500 colorFFF`}
                        style={{ backgroundColor: card?.tagColor || DEFAULT_TAG_COLOR }}
                      >
                        {card.tag}
                      </div>
                    )}
                    <div className={gridStyles.CardBody}>
                      <div className={gridStyles.ImageBox}>
                        <img className={gridStyles.Image} src={card?.image} alt={card?.name || ''} loading="lazy" />
                      </div>
                      <div className={gridStyles.Content}>
                        <div className={`${gridStyles.Title} font13 fw600 color111`}>{card?.name}</div>
                        {hasPriceRow && (
                          <div className={`${gridStyles.PriceRow} mt-5`}>
                            {card?.oldPrice && (
                              <span className={`${gridStyles.OldPrice} font11 fw400 color777`}>{card.oldPrice}</span>
                            )}
                            {card?.off && <span className={`${gridStyles.Off} font10 fw600`}>{card.off}</span>}
                            {card?.trending && (
                              <span className={`${gridStyles.Trending} font10 fw500 colorFFF`}>Trending</span>
                            )}
                          </div>
                        )}
                        {card?.priceLabel && (
                          <div className={`${gridStyles.PriceLabel} font11 fw400 color777 mt-10`}>
                            {card.priceLabel}
                          </div>
                        )}
                        {card?.price && (
                          <div className={`${gridStyles.Price} color111`}>
                            <span className={gridStyles.PriceValue}>{card.price}</span>
                          </div>
                        )}
                        <div className={`${gridStyles.Actions} mt-10`}>
                          <button
                            type="button"
                            className={`${gridStyles.BuyBtn} font12 fw600`}
                            onClick={() => handleBuy(card)}
                          >
                            {card?.cta || 'Buy Now'}
                            <span className={gridStyles.Chevron} />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </section>
        </div>
      </div>
    </section>
  );
};

export default BizBoosterModal;

BizBoosterModal.propTypes = {
  addOnsData: PropTypes.arrayOf(
    PropTypes.shape({
      campid: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      name: PropTypes.string,
      image: PropTypes.string,
      redirectionUrl: PropTypes.string,
      trackerId: PropTypes.string,
      tag: PropTypes.string,
      tagColor: PropTypes.string,
      bgColor: PropTypes.string,
      oldPrice: PropTypes.string,
      off: PropTypes.string,
      trending: PropTypes.bool,
      priceLabel: PropTypes.string,
      price: PropTypes.string,
      cta: PropTypes.string,
    }),
  ),
  setAddOnsData: PropTypes.func,
};
